import React, { useState } from "react";
import Modal from "../utils/Modal/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as StarIcon } from "../../assets/icons/star.svg";

import {
  ModalContainer,
  PromptCloseButton,
  PromptInputContainer,
  PromptInputTitle,
  PromptModalButtons,
  PromptModalHeader,
  PromptModalTitle,
  PromptSeedInput,
  PromptTextarea,
  Buttons,
  Button,
  PromptRow,
  RelativeContainer,
  SummaryContainer,
  EstTimeContainer,
  EstTimeText,
  CancelButton,
  ConfirmButton,
} from "../EnterPromptModal/EnterPromptModal.styles";

export const VIDEO_DURATION_OPTIONS = [
  { id: "5", label: "5s", frames: 126 },
  { id: "8", label: "8s", frames: 201 },
  { id: "10", label: "10s", frames: 251 },
  { id: "15", label: "15s", frames: 376 },
];

export const VIDEO_RESOLUTION_OPTIONS = [
  { id: "LOW", label: "Low", width: 488, height: 832 },
  { id: "MEDIUM", label: "Medium", width: 1080, height: 1280 },
  { id: "HIGH", label: "High", width: 1080, height: 1920 },
];

const generateRandomSeed = () =>
  Math.floor(Math.random() * 10000000) + 1;

const VideoSettingsModal = ({
  isOpen,
  onClose,
  duration,
  setDuration,
  resolution,
  setResolution,
  negativePrompt,
  setNegativePrompt,
  seedNumber,
  setSeedNumber,
  totalPrice,
  overlayZIndex = 3500,
}) => {
  const [seedMode, setSeedMode] = useState(
    () => localStorage.getItem("videoSeedMode") || "random",
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: overlayZIndex }}
    >
      <ModalContainer>
        <PromptModalHeader>
          <PromptModalTitle>Video Settings</PromptModalTitle>
          <PromptCloseButton onClick={onClose}>
            <CloseIcon />
          </PromptCloseButton>
        </PromptModalHeader>

        <PromptInputContainer>
          <PromptInputTitle>Duration</PromptInputTitle>
          <Buttons>
            {VIDEO_DURATION_OPTIONS.map((option) => (
              <Button
                key={option.id}
                $active={duration === option.id}
                onClick={() => {
                  setDuration(option.id);
                  localStorage.setItem("videoDuration", option.id);
                }}
              >
                {option.label}
              </Button>
            ))}
          </Buttons>
        </PromptInputContainer>

        <PromptInputContainer>
          <PromptInputTitle>Resolution</PromptInputTitle>
          <Buttons>
            {VIDEO_RESOLUTION_OPTIONS.map((option) => (
              <Button
                key={option.id}
                $active={resolution === option.id}
                onClick={() => {
                  setResolution(option.id);
                  localStorage.setItem("videoResolution", option.id);
                }}
              >
                {option.label}
              </Button>
            ))}
          </Buttons>
        </PromptInputContainer>

        <PromptInputContainer>
          <PromptInputTitle>Seed</PromptInputTitle>
          <PromptRow>
            <Buttons>
              <Button
                $active={seedMode === "random"}
                onClick={() => {
                  setSeedMode("random");
                  localStorage.setItem("videoSeedMode", "random");
                  setSeedNumber(generateRandomSeed());
                }}
              >
                Random
              </Button>
              <Button
                $active={seedMode === "custom"}
                onClick={() => {
                  setSeedMode("custom");
                  localStorage.setItem("videoSeedMode", "custom");
                }}
              >
                Custom
              </Button>
            </Buttons>
            <PromptSeedInput
              type="number"
              placeholder="Seed..."
              value={seedNumber}
              min={1}
              max={9007199254740991}
              disabled={seedMode === "random"}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0 && value <= 9007199254740991) {
                  setSeedNumber(value > 0 ? value : 1);
                  if (seedMode === "custom") {
                    localStorage.setItem(
                      "videoCustomSeed",
                      value > 0 ? value : 1,
                    );
                  }
                }
              }}
            />
          </PromptRow>
        </PromptInputContainer>

        <PromptInputContainer>
          <PromptInputTitle>Negative Prompt</PromptInputTitle>
          <RelativeContainer>
            <PromptTextarea
              placeholder="Enter Negative Prompt"
              value={negativePrompt}
              onChange={(e) => setNegativePrompt(e.target.value)}
            />
          </RelativeContainer>
        </PromptInputContainer>

        <SummaryContainer>
          <EstTimeContainer>
            <EstTimeText>Cost:</EstTimeText>
            <StarIcon />
            <EstTimeText $bold>{totalPrice}</EstTimeText>
          </EstTimeContainer>
        </SummaryContainer>

        <PromptModalButtons>
          <ConfirmButton $type="primary" onClick={onClose}>
            Save
          </ConfirmButton>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        </PromptModalButtons>
      </ModalContainer>
    </Modal>
  );
};

export default VideoSettingsModal;
